<template>
  <div class="kanban-column flex h-full w-72 flex-shrink-0 flex-col rounded-lg bg-n-alpha-1">
    <div
      class="flex items-center justify-between rounded-t-lg px-3 py-2"
      :style="{ borderTop: `3px solid ${stage.color || '#1F93FF'}` }"
    >
      <div class="flex items-center gap-2">
        <h3 class="m-0 text-sm font-semibold text-n-slate-12">
          {{ stage.name }}
        </h3>
        <span class="rounded-full bg-n-alpha-2 px-2 py-0.5 text-xs font-medium text-n-slate-11">
          {{ conversations.length }}
        </span>
      </div>
    </div>
    <div class="flex-1 overflow-y-auto px-2 pb-2">
      <draggable
        :list="conversations"
        :group="{ name: 'kanban', pull: true, put: true }"
        item-key="id"
        class="flex min-h-[50px] flex-col gap-2"
        ghost-class="kanban-ghost"
        drag-class="kanban-drag"
        @change="onDragChange"
      >
        <template #item="{ element }">
          <KanbanCard :conversation="element" @click="$emit('card-click', element)" />
        </template>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import KanbanCard from './KanbanCard.vue';

export default {
  name: 'KanbanColumn',
  components: {
    draggable,
    KanbanCard,
  },
  props: {
    stage: {
      type: Object,
      required: true,
    },
    conversations: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['card-click', 'card-moved'],
  methods: {
    onDragChange(evt) {
      if (evt.added) {
        this.$emit('card-moved', {
          conversation: evt.added.element,
          stageId: this.stage.id,
        });
      }
    },
  },
};
</script>

<style scoped>
.kanban-ghost {
  opacity: 0.4;
  background: #e8f4ff;
  border-radius: 8px;
}
.kanban-drag {
  transform: rotate(2deg);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}
</style>
